import { Fragment } from 'react';

import type { ProfilePageSettings } from 'src/components/Profile/CreateResume/reducer';

const featureStore: Record<string, boolean> = {};

export const hydrateFeatures = ({
  features = '',
}: ProfilePageSettings = {}) => {
  features.split(',').forEach((feature) => {
    featureStore[feature] = true;
  });
};

const activeFeatures = [
  'shareable-profile',
  'profile-insights',
  'profile-suggestions',
  'profile-strengths',
  'verifications-nudge',
] as const;
type FeatureName = (typeof activeFeatures)[number];

export const isFeatureActive = (featureName: FeatureName): boolean => {
  const windowIsUndefined = typeof window === 'undefined';

  // This condition can be removed when the 'shareable-profile' feature is removed
  if (windowIsUndefined) {
    return false;
  }

  const env =
    !windowIsUndefined && window.APP_CONFIG ? window.APP_CONFIG.SEEK_ENV : '';

  if (env === 'test' && featureName === 'shareable-profile') {
    return false;
  }

  // This condition can be removed when the 'profile-strengths' feature is removed.
  // This condition will allow cypress tests to pass.
  if (env === 'test' && featureName === 'profile-strengths') {
    return true;
  }

  // By default hide profile-strength feature on dev
  if (env !== 'prod' && featureName !== 'profile-strengths') {
    return true;
  }

  // By default hide verifications feature on dev
  if (env !== 'prod' && featureName !== 'verifications-nudge') {
    return true;
  }

  return Boolean(featureStore[featureName]);
};

export const FeatureFlag = ({
  children,
  name,
}: {
  children: React.ReactNode;
  name: FeatureName;
}) => (isFeatureActive(name) ? <Fragment>{children}</Fragment> : null);
